import { Injectable } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { Label } from '@client/app/feature-modules/admin/modules/admin-labels/types/label.type';
import { RequestParamsType } from '@monsido/ng2/external/http/options';
import { ApiService } from '@client/app/services/api/api-service/api.service';
import { BaseRepo, BaseRepoRequestType } from '@client/app/services/api/base-repo/base-repo';
import { MonTableCollection } from '@client/ng2/models/table-collection.interface';
import { DEFAULT_PAGE_SIZE } from '@client/app/shared-modules/api/constants/page-size.constant';
import { contextTokens } from '@monsido/services/request-auxiliary/request-auxiliary.service';
import { LabelDomainGroup } from '../types/labelDomainGroups.type';

type LabelRepoRequestType = RequestParamsType & BaseRepoRequestType;
@Injectable({
    providedIn: 'root',
})
export class LabelsRepo extends BaseRepo {
    constructor (
        private apiService: ApiService,
        protected sessionService: SessionService,
    ) {
        super();
    }

    getLabels (params: LabelRepoRequestType = {}) {
        params.page_size = params.page_size || DEFAULT_PAGE_SIZE;
        return this.apiService.get<MonTableCollection<Label>>('labels', params, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }

    createLabel (params: LabelRepoRequestType) {
        return this.apiService.post<Label>('labels', params, contextTokens.REDESIGN_ERROR_ALERT);
    }

    deleteLabel (params: LabelRepoRequestType) {
        return this.apiService.delete<void>(`labels/${params.id}`, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }

    updateLabel (params: LabelRepoRequestType) {
        return this.apiService.patch<Partial<Label>>(`labels/${params.id}`, params, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }

    getDomainGroupsUsingLabel (labelId: number): Promise<LabelDomainGroup[]> {
        return this.apiService.get(`labels/${labelId}/domains_with_blocking_groups`, undefined, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }
}
